<sc-flex fitHeight vertical stretchContent>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>
      <sc-flex vertical stretchContent [gap]="16">
        @for (truck of currentTruckGroup.trucks; track truck) {
          <app-truck (removeTruck)="removeTruck($event)" editable [truck]="truck"
          ></app-truck>
        }
      </sc-flex>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
  <sc-content-spacer vertical></sc-content-spacer>
  <div>
    <sc-flex centered>
      <sc-add-action-button (click)="onAdd()" large></sc-add-action-button>
    </sc-flex>
  </div>
</sc-flex>
